import { useLocation } from 'shared/hooks/useLocation';
import { t } from 'localization/utils/t';

const TP = 'tracking.components.OneTrustLink';

declare global {
  interface Window {
    OneTrust: any;
  }
}

/**
 * This custom link is necessary due to how One Trust injects their link onto our
 * site and how nextjs renders our footer. This implementation was taken from FC
 * https://github.com/goatapp/flightclub.com/blob/main/src/layout/footer/OneTrustLink.tsx
 */
export const OneTrustLink = () => {
  const { selectedCountryCode } = useLocation();

  return (
    <button
      type="button"
      id="one-trust-footer-link"
      data-qa="footer_one_trust_link"
      onClick={() => {
        window.OneTrust?.ToggleInfoDisplay?.();
      }}
    >
      {selectedCountryCode === 'US'
        ? t(`${TP}.privacyChoices`, 'Your Privacy Choices')
        : t(`${TP}.cookiesSettings`, 'Cookies Settings')}
    </button>
  );
};
